// import React, { useState } from "react";
// import { Tooltip, FormFeedback } from "reactstrap";

// const RadioGroup = ({
//     label = "Select an Option",
//     options = [],
//     required = false,
//     onChange = () => {},
//     showHelp = false,
//     helpText = "",
//     requiredErrorMessage = "Please select one option.",
//     customError = null,
//     layout = "below",
//     radioStyles = {}
// }) => {
//     const [selectedOption, setSelectedOption] = useState(null);
//     const [errors, setErrors] = useState(false);
//     const [tooltipOpen, setTooltipOpen] = useState(false);

//     // Handle radio change
//     const handleChange = (option) => {
//         setSelectedOption(option.value); // Use the value of the option
//         setErrors(false);
//         onChange(option.value); // Pass the value to the onChange handler
//     };

//     // Validate selection on form submission
//     const validateSelection = () => {
//         if (required && selectedOption === null) {
//             setErrors(true);
//         }
//     };

//     return (
//         <div>
//             <label className="d-flex" style={{ alignItems: 'center' }}>
//                 {label}{required && <span className="text-danger">*</span>}
//                 {showHelp && (
//                     <span
//                         id={`help-${label.replace(/\s+/g, '-').toLowerCase()}`}
//                         className="px-2"
//                         style={{ cursor: 'pointer' }}
//                         onMouseEnter={() => setTooltipOpen(true)}
//                         onMouseLeave={() => setTooltipOpen(false)}
//                     >
//                         <i className="ri-question-line" style={{ fontSize: '16px' }} />
//                     </span>
//                 )}
//             </label>
//             {showHelp && (
//                 <Tooltip
//                     placement="right"
//                     isOpen={tooltipOpen}
//                     target={`help-${label.replace(/\s+/g, '-').toLowerCase()}`}
//                 >
//                     {helpText}
//                 </Tooltip>
//             )}
//             <div className={layout === "inline" ? "d-flex" : ""}>
//                 {options.map((option, index) => (
//                     <div key={index} className={`form-check ${layout === "inline" ? "mr-3" : ""}`}>
//                         <input
//                             type="radio"
//                             id={`radio-${index}`}
//                             className="form-check-input"
//                             checked={selectedOption === option.value}
//                             onChange={() => handleChange(option)}
//                             onBlur={validateSelection}
//                             style={radioStyles}
//                         />
//                         <label className="form-check-label" htmlFor={`radio-${index}`}>
//                             {option.label}
//                         </label>
//                     </div>
//                 ))}
//             </div>
//             {errors && (
//                 <FormFeedback type="invalid">
//                     {customError || requiredErrorMessage}
//                 </FormFeedback>
//             )}
//         </div>
//     );
// };

// export default RadioGroup;


import React, { useState, useEffect } from "react";
import { Tooltip, FormFeedback } from "reactstrap";

const RadioGroup = ({
    label = "Select an Option",
    options = [],
    required = false,
    onChange = () => {},
    value = null,
    showHelp = false,
    helpText = "Please select it.",
    requiredErrorMessage = "Please select one option.",
    customError = null,
    layout = "below", // "inline" or "below" for label positioning
    listLayout = "inline", // "inline" or "below" for radio button positioning
    radioStyles = {},
    validateTrigger // Trigger validation from the parent form
}) => {
    const [selectedOption, setSelectedOption] = useState(value);
    const [errors, setErrors] = useState(false);
    const [tooltipOpen, setTooltipOpen] = useState(false);

    // Handle radio change
    const handleChange = (option) => {
        setSelectedOption(option.value);
        setErrors(false);
        onChange(option.value);
    };

    // Update selected option when value prop changes
    useEffect(() => {
        setSelectedOption(value);
    }, [value]);

    // Validate selection
    const validateSelection = () => {
        if (required && selectedOption === null) {
            setErrors(true);
        } else {
            setErrors(false);
        }
    };

    // Trigger validation when validateTrigger changes
    useEffect(() => {
        if (validateTrigger) {
            validateSelection();
        }
    }, [validateTrigger]);

    return (
        <div className={layout === "inline" ? "d-flex align-items-center" : "mb-2"}>
            {/* Label Section */}
            <label className="d-flex" style={{ width: layout === "inline" ? "25%" : "100%" }}>
                {label}
                {required && <span className="text-danger">*</span>}

                {showHelp && (
                    <span
                        id={`help-${label.replace(/\s+/g, "-").toLowerCase()}`}
                        className="px-1"
                        style={{ position: "relative", top: "-3px", cursor: "pointer" }}
                        onMouseEnter={() => setTooltipOpen(true)}
                        onMouseLeave={() => setTooltipOpen(false)}
                    >
                        <i className="ri-question-line" style={{ fontSize: "16px" }} />
                    </span>
                )}
            </label>
            {showHelp && (
                <Tooltip
                    placement="right"
                    isOpen={tooltipOpen}
                    target={`help-${label.replace(/\s+/g, "-").toLowerCase()}`}
                >
                    {helpText}
                </Tooltip>
            )}

            {/* Radio Buttons Section */}
            <div className={`w-100 ${listLayout === "inline" ? "d-flex align-items-center" : "d-flex flex-column"}`}>
                {options.map((option, index) => (
                    <div key={index} className={`form-check ${listLayout === "inline" ? "me-3" : "mb-2"}`}>
                        <input
                            type="radio"
                            id={`radio-${index}`}
                            className="form-check-input"
                            checked={selectedOption === option.value}
                            onChange={() => handleChange(option)}
                            onBlur={validateSelection}
                            style={radioStyles}
                        />
                        <label className="form-check-label" htmlFor={`radio-${index}`}>
                            {option.label}
                        </label>
                    </div>
                ))}
            </div>

            {/* Error Message */}
            {errors && (
                <FormFeedback type="invalid" className="d-block">
                    {customError || requiredErrorMessage}
                </FormFeedback>
            )}
        </div>
    );
};

export default RadioGroup;

